import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-2xl mx-auto px-6 py-28 text-center" data-testid="payment-cancel">
      <XCircle className="mx-auto text-ape-muted mb-6" size={56} />
      <h1 className="font-display text-4xl tracking-tight">PAYMENT CANCELLED</h1>
      <p className="text-ape-muted mt-4">No charge was made. Your order is still reserved — you can complete payment any time from your account.</p>
      <div className="flex gap-3 justify-center mt-8">
        <Link to="/account" className="bg-ape-red hover:bg-ape-redhover text-white font-head uppercase tracking-widest px-8 py-4 transition-colors duration-150">My Orders</Link>
        <Link to="/shop" className="border-2 border-ape-red text-ape-red hover:bg-ape-red hover:text-white font-head uppercase tracking-widest px-8 py-4 transition-colors duration-150">Keep Shopping</Link>
      </div>
    </div>
  );
}
